import { render } from "./AddImages.vue?vue&type=template&id=4fa6b020&scoped=true&ts=true"
import script from "./AddImages.vue?vue&type=script&lang=ts"
export * from "./AddImages.vue?vue&type=script&lang=ts"

import "./AddImages.vue?vue&type=style&index=0&id=4fa6b020&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa6b020"]])

export default __exports__